import React, { useCallback, useEffect, useState }  from 'react';
import Amplify, { Auth } from 'aws-amplify';
import { withAuthenticator } from 'aws-amplify-react';
import awsConfig from './lib/amplify';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';

import logoMarkSvg from './svg/logo-mark.svg';
import logoTextSvg from './svg/logo-text.svg';

//pages

import Cameras from './pages/Cameras';


import { MainMenu, Layout, TopBar} from 'scorer-ui-kit';
import menu from './pages/menu.json';
import Login from './pages/Login';
import styled from 'styled-components';
import { useUsername } from './hooks/useUsername';
import NewAnalysisJob from './pages/NewAnalysisJob';
import CameraDetails from './pages/CameraDetails';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';

const MainContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;



Amplify.configure(awsConfig);




const App: React.FC<{}> = () => {
  const {username, signOut} = useUsername();
  const { t } = useTranslation(['Common']);
  const [translatedMenu, setTranslatedMenu] = useState(menu);
  const versionInfo = {
    icon: 'Information',
    title: 'TCC 2022.12.21'
  };

  const onLanguageChange = useCallback(() => {
    const language = i18n.language === 'ja' ? 'en' : 'ja';
    i18n.changeLanguage(language);
    localStorage.setItem('language', language);
  },[]);

  useEffect(() => {
    const translatedMenu = {
      items: menu.items.map(({title,...rest}) => ({title: t(title),...rest}))
    };
    setTranslatedMenu(translatedMenu);
  },[t]);

  return (
    <Router>
      <Layout>
        <MainMenu content={translatedMenu} logoMark={logoMarkSvg} logoText={logoTextSvg} />

        <MainContainer>

          <TopBar
            loggedInUser={username}
            logoutLink='/'
            onLogout={signOut}
            hasLanguage
            onLanguageToggle={onLanguageChange}
            logoutText={t('logout')}
            currentUserText={t('currentUser')}
            userDrawerFooter={versionInfo}
          />
          <Switch>
            <Route path='/' exact component={Cameras} />
            <Route path='/cameras/:lid' exact component={CameraDetails} />
            <Route path='/cameras/:lid/analysis/create' exact component={NewAnalysisJob} />
          </Switch>
        </MainContainer>

      </Layout>
    </Router>
  );
};

export default withAuthenticator(App, false,[
  <Login key='login' onLogin={({username, password}) =>  Auth.signIn(username,password)} />
]);